import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/forms/icon.component';

interface PrincipalCardProps {
  btnBack?: boolean;
  title: React.ReactNode;
  titleBolder: string;
  subtitle: string;
  breadcrumbItems: string[];
  stepper?: React.ReactNode;
  route?: string;
}

const PrincipalCard: React.FC<PrincipalCardProps> = ({
  btnBack = false,
  title = '',
  titleBolder = '',
  subtitle = '',
  breadcrumbItems = [],
  stepper,
  route = ''
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const routePath: any = route ? route : -1;
  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <span className="d-flex flex-column">
          <ul className="breadcrumb fw-semibold fs-base my-1">
            {breadcrumbItems.map((item) => (
              <li key={item} className="breadcrumb-item">
                {t(item)}
              </li>
            ))}
          </ul>
          <span className="d-flex flex-column mb-7">
            <span className="fw-bold fs-1">
              {title}
              <span className="text-info fw-bolder ms-2">{titleBolder}</span>
            </span>
            <span className="fs-6 text">{subtitle}</span>
          </span>
        </span>
        {btnBack && (
          <div className="d-flex align-items-center flex-nowrap text-nowrap py-1">
            <span className="d-flex align-items-center">
              <button
                className="btn symbol symbol-circle symbol-50px hover-scale cursor-pointer d-flex align-items-center"
                onClick={() => navigate(routePath)}
                type="button"
              >
                <span className="symbol-label bg-light-info">
                  <Icon icon="ki-double-left" size="fs-2x" type="info" />
                </span>
                <span className="fw-bolder ms-2"> {t('general.return')}</span>
              </button>
            </span>
          </div>
        )}
      </div>
      {stepper && <div className="mb-20">{stepper}</div>} {/* Renderizado condicional */}
    </>
  );
};

export default PrincipalCard;
